import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { map, range } from 'lodash';

import Star from 'components/svg/Star';
import Dollar from 'components/svg/Dollar';

import './StarRating.scss';

export default function StarRating({
	className,
	rating = 0,
	outOf = 5,
	dollar,
	fillColor,
	width,
	height,
}) {
	return (
		<div className={classnames('star-rating', className)}>
			{map(range(0, outOf), (starValue) =>
				dollar ? (
					<Dollar />
				) : (
					<Star
						width={width}
						height={height}
						key={starValue}
						value={rating - starValue}
						fillColor={fillColor}
					/>
				),
			)}
		</div>
	);
}

StarRating.propTypes = {
	className: PropTypes.string,
	/** The rating to show */
	rating: PropTypes.number,
	/** What the rating is out of */
	outOf: PropTypes.number,
	dollar: PropTypes.bool,
	fillColor: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
};

